import { Undo2, Users } from 'lucide-react';
import React from 'react';
import { useAutomationEditorContext } from '../AutomationEditorContext';
import { useEditorSyncStatus } from '../EditorSyncStatusContext';
import styles from './TenantSelectionControl.module.css';

interface TenantSelectionControlProps {
  onOpen: () => void;
}

export const TenantSelectionControl: React.FC<TenantSelectionControlProps> = ({ onOpen }) => {
  const { editor } = useAutomationEditorContext();
  const { state, undoTenantSelection } = editor;
  const isDirty = state.dirtySteps.tenantSelection;
  const disabled = useEditorSyncStatus();

  return (
    <>
      {isDirty && (
        <button
          type="button"
          onClick={undoTenantSelection}
          className={styles.undoButton}
          aria-label="Undo tenant selection changes"
          title="Undo tenant selection changes"
          disabled={disabled}>
          <Undo2 />
        </button>
      )}
      <button
        type="button"
        onClick={onOpen}
        className={`${styles.tenantButton} ${isDirty ? styles.tenantButtonDirty : ''}`}
        disabled={disabled}
        title={disabled ? 'Not available while sync is in progress' : 'Tenant selection'}
        aria-label="Tenant selection">
        <Users className={styles.tenantIcon} />
        {isDirty && <span className={styles.dirtyDot} />}
      </button>
    </>
  );
};
